(function () {
    "use strict";

    var controllerId = "studRegistraClasse";
    angular.module('app').controller(controllerId, ["$scope", "$rootScope", "$filter", "$uibModalInstance", "datacontext", "common", '$translate', studRegistraClasseFn]);

    function studRegistraClasseFn($scope, $rootScope, $filter, $uibModalInstance, datacontext, common, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.item = {};
        $scope.item.index = 1;
        $scope.item.classe = {};
        $scope.currentLanguage = $translate.proposedLanguage() || $translate.use();

        $scope.avanti = function () {
            datacontext.classe_verificaCodice($scope.item.codice).then(function (data) {
                if (data && data.Id > 0 ){
                    $scope.item.index = 2;
                    $scope.item.classe = data;
                }                    
                else {
                    logError($translate.instant('CodiceNonValido'));                 
                }
            });
        };

        $scope.ok = function (isValid) {
            datacontext.classe_studenteRegistra($scope.item.classe.Id).then(function (data) {
                if (data == "200") {
                    $uibModalInstance.close();
                    logSuccess($translate.instant('RegistrazioneCompletata'));                 
                }
                else {
                    logError($translate.instant('ErroreInterno'));
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };        
    }
})();